<template>
  <div class="cms-grid" :class="gridClass">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

interface Props {
  columns?: number;
  minWidth?: string;
  gap?: 'sm' | 'md' | 'lg';
}

const props = withDefaults(defineProps<Props>(), {
  columns: 3,
  minWidth: '300px',
  gap: 'md'
});

const gridClass = computed(() => {
  return [`cms-grid-gap-${props.gap}`];
});
</script>

<style lang="scss" scoped>
@import './cms-styles.scss';

.cms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(v-bind(minWidth), 1fr));
  
  &-gap-sm {
    gap: $cms-spacing-sm;
  }
  
  &-gap-md {
    gap: $cms-spacing-lg;
  }
  
  &-gap-lg {
    gap: $cms-spacing-xl;
  }
}

@include cms-responsive-mobile {
  .cms-grid {
    grid-template-columns: 1fr;
  }
}
</style>

